import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SchedulerFrequencyClient, SchedulerFrequencyDto } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class SchedulerFrequencyService {
    constructor(private readonly client: SchedulerFrequencyClient) {}

    async getAll(): Promise<SchedulerFrequencyDto[]> {
        return await lastValueFrom(this.client.schedulerFrequencyGetAllSchedulerFrequency());
    }
}
